import { observer } from 'mobx-react-lite'
import { Navigate } from 'react-router-dom'
import { useUsersIndex } from 'app/components/users-index/useUsersIndex'
import { UsersIndexShadcnComponent } from 'app/components/users-index/UsersIndexShadcnComponent'
import { useCheckPermission } from 'app/hooks/useCheckPermission'
import { useFeatureToggle } from 'app/hooks/useFeatureToggle'
import { useUser } from 'app/utils'

export default observer(function UsersIndex(): React.ReactElement {
  const me = useUser()
  const staffV2Enabled = useFeatureToggle(`staff-v2`)
  const checkPermission = useCheckPermission()
  const { users, columns, filters, initialSort, canEditUser, userIsOrg, onSearchValueChange } = useUsersIndex()

  if (!me) return <></>

  // Staff-v2 with workspace context redirects to active tab
  if (staffV2Enabled && me.workspaceId) {
    return <Navigate to="/settings/users/active" replace />
  }

  // Permission check when staff-v2 is ON
  if (staffV2Enabled) {
    const canManageUsers = me.type === `super` || checkPermission([`org:settings:manage-users`, `users:manage`])
    if (!canManageUsers) {
      return <Navigate to="/" replace />
    }
  }

  return (
    <UsersIndexShadcnComponent
      users={users}
      columns={columns}
      filters={filters}
      initialSort={initialSort}
      canEditUser={canEditUser}
      userIsOrg={userIsOrg}
      isSuperUser={me.type === `super`}
      inWorkspace={!!me.workspaceId}
      staffV2Enabled={staffV2Enabled}
      onSearchValueChange={onSearchValueChange}
    />
  )
})
